import { isNullOrUndefinedOrWhitespace, EMPTY_STRING, isAFailedHttpResponse } from '@/utils/common'

/**
 * This class is meant to simplify access to http error messages, especially from  the public endpoints
 */
export class HttpResponse {
  constructor (httpResponse) {
    this.hasError = isAFailedHttpResponse(httpResponse)
    this.errorMessage = this.parseErrors(httpResponse)
    this.data = httpResponse.data || (httpResponse.response && httpResponse.response.data)
    this.rawResponse = httpResponse
  }
  /**
   * accepts a http response and returns the parsed error message(s) as a comma separeted string. The response shape resembles one from our public apis
   */
  parseErrors ({ response, message }) {
    if (!this.hasError) {
      return EMPTY_STRING
    } else if (response === undefined) {
      return message
    }
    if (!isNullOrUndefinedOrWhitespace(response.data.title)) {
      return response.data.title
    }
    if (Object.keys(response.data).length > 0) {
      let message = EMPTY_STRING
      for (let key in response.data) {
        const value = response.data[key]
        if (Array.isArray(value) && value.length > 0) {
          message += value.join(',')
        }
      }
      return message
    }
    return EMPTY_STRING
  }
}
